// export.ts — CSV export of the local ledger (all local; nothing leaves the device).

import type { Txn } from "./store";
import { categoryLabel } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Full CSV: Date, Account, Merchant, Description, Category, Amount, Currency.
 *  Amount is exported in MAJOR units, signed (debits negative, credits positive). */
export function txnsCsv(txns: Txn[], accountName: (id: string) => string): string {
  return csv(
    ["Date", "Account", "Merchant", "Description", "Category", "Amount", "Currency"],
    txns.map((t) => [
      t.posted_on,
      accountName(t.account_id),
      t.merchant,
      t.raw_description,
      categoryLabel(t.category),
      (t.amount / 100).toFixed(2),
      t.currency,
    ]),
  );
}

export function buildExport(txns: Txn[], accountName: (id: string) => string): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: txnsCsv(txns, accountName), filename: `statements-${stamp}.csv` };
}
